export const lottieDurationMs = 4720; // Logged from the lottie controller object on load
